<div fxFlex="100" class="inputs">
    <div fxFlex="100" class="leaseRequest">
        <div class="leasebox">
            <div class="inputs" *ngFor="let contact of contacts, let i=index">
                <div fxFlex="12.3em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Point of Contact*</span>
                    </div>
                    <app-mat-auto-search [isEditable]="true" fxFlex="100" ngModel
                        (ngModelChange)="fetchUserDetails($event, i)" [idField]="null" [name]="'user'+i"
                        [listUrl]="base_url + 'user_list/?is_internal=1&search=::search::'" [trim]="true"
                        [searchable]="true" [labelItemTemplate]="userSelectedItem" [itemTemplate]="userItem"
                        class="align-items-center" [showCustom]="true"></app-mat-auto-search>
                </div>
                <div fxFlex="12.3em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Name*</span>
                    </div>
                    <app-text-field [isEditable]="true" [(ngModel)]="contact.contact_name"
                        [name]="'name'+i"></app-text-field>
                </div>
                <div fxFlex="12.3em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Role*</span>
                    </div>
                    <app-text-field [isEditable]="true" [(ngModel)]="contact.profile_role" [name]="'role'+i"></app-text-field>
                </div>
                <div fxFlex="12.3em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Email*</span>
                    </div>
                    <app-text-field [isEditable]="true" [(ngModel)]="contact.contact_email"
                        [name]="'email'+i"></app-text-field>
                </div>
                <div fxFlex="12.3em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Contact No*</span>
                    </div>
                    <app-text-field [isEditable]="true" [(ngModel)]="contact.contact_number"
                        [name]="'number'+i"></app-text-field>
                </div>

                <div class="actionBtn">
                    <i class="flaticon-delete" (click)="removeContact(i)" matTooltip="Delete" matTooltipPosition="below"
                        matTooltipHideDelay="2000" *ngIf="contacts.length > 1"></i>
                </div>
            </div>
        </div>
        <span class="addReq" (click)="addContactDetails()" matTooltip="Add New Contact" matTooltipPosition="left"
            matTooltipHideDelay="2000">Add</span>
    </div>
</div>

<ng-template #userItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.first_name}} {{item?.last_name}} {{ item?.value }}
        </span>
        <span class="email">
            {{item?.email}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{item?.first_name}} {{item?.last_name}} {{ item?.value }}
</ng-template>